// Parseo manual de YYYY-MM-DD para evitar shifts de timezone.
// `new Date("2022-03-15")` interpreta como UTC midnight; en CR (UTC-6)
// se renderiza como "14 mar". Construyendo el Date con (year, month-1, day)
// se queda en local time, que es lo que el usuario espera ver.
function parseIsoDate(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    !Number.isInteger(day) ||
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31
  ) {
    return null;
  }
  return new Date(year, month - 1, day);
}

const DATE_FORMATTER = new Intl.DateTimeFormat("es-CR", {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

// "2022-03-15" → "15 mar 2022". Devuelve "—" si el input no parsea.
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = parseIsoDate(iso);
  if (!date) return "—";
  // Intl en es-CR devuelve "15 mar 2022" sin trailing dot — pero algunos
  // runtimes meten "mar." con punto. Lo normalizamos sacando puntos.
  return DATE_FORMATTER.format(date).replace(/\./g, "");
}
